import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, Matches, IsNotEmpty, IsOptional, MaxLength } from "class-validator";

export class DefectDto {
    @ApiProperty()
    @IsNotEmpty({ message: "defect Id should not be empty" })
    @IsAlphanumeric()
    defectId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Defect Name should not be empty" })
    @IsAlphanumeric()
    @IsOptional()
    defectName: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(50, { message: "Created User allows maximum 50 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(50, { message: "Updated User allows maximum 50 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}